import { documentLibraryOrgPermissions } from '@juvare/document-library/backend/features/permissions';
const groupName = 'Mission';
export const missionSystemPermissions = {
    /**
     * mission management
     */
    'manage-missions': {
        group: groupName,
        label: 'Manage Missions',
    },
    'manage-mission-classifiers': {
        group: groupName,
        label: 'Manage Mission Classifiers',
    },
    'manage-mission-location-type-classifier': {
        group: groupName,
        label: 'Manage Mission Location Type Classifier',
    },
    'manage-mission-location-classifier': {
        group: groupName,
        label: 'Manage Mission Location Classifier',
    },
    'manage-mission-position-classifier': {
        group: groupName,
        label: 'Manage Mission Position Classifier',
    },
    'manage-mission-type-classifier': {
        group: groupName,
        label: 'Manage Mission Type Classifier',
    },
    'manage-time-tracking': {
        group: groupName,
        label: 'Allow To Manage Time Tracking',
    },
    'allow-self-withdraw': {
        group: groupName,
        label: 'Allow Self Withdraw',
    },
    'allow-create-public-mission': {
        group: groupName,
        label: 'Allow To Create Public Mission',
    },
    'manage-all-admin-missions': {
        group: groupName,
        label: 'Manage All Admin Missions',
    },
};
export const missionOrgPermissions = Object.assign({}, documentLibraryOrgPermissions);
